/**
 * Shared draft-run helpers used by the Pending Orders tab (own-driver dispatch)
 * and useThirdPartyBooking (courier booking) — extracted so both build identical
 * mobility_stops rows.
 */

/** Orders group into destinations by normalized delivery address. */
export const normAddr = (a: any): string => (a || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');

/**
 * mobility_stops insert for a destination (carries location_id when known) +
 * nested delivery_stop_detail (recipient). All the destination's orders are
 * assigned to it afterwards.
 */
export const buildStopForDestination = (runId: number, dest: any, stopOrder: number) => ({
  run_id: runId,
  product_type: 'parts_delivery',
  status: 'pending',
  stop_order: stopOrder,
  location_id: dest.location_id || null,
  address: dest.address || null,
  address_lat: dest.delivery_lat || null,
  address_lng: dest.delivery_lng || null,
  delivery_stop_detail: {
    data: [
      {
        recipient_business: dest.recipient_business || null,
        recipient_name: dest.recipient_name || null,
        recipient_phone: dest.recipient_phone || null,
      },
    ],
  },
});
